import React, { useEffect, useRef, forwardRef } from 'react';
/**
 *
 * @param root0
 * @param root0.children
 * @param root0.registerChild
 * @param root0.measure
 * @param root0.index
 * @param root0.style
 * @param root0.isVisible
 * @param root0.isScrolling
 * @param root0.onMouseMove
 * @example
 */
// The `CellMeasurer` component from react-virtualized expects that his children is a `forwardRef` component.
export var ListRow = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    measure = _ref.measure,
    index = _ref.index,
    style = _ref.style,
    isVisible = _ref.isVisible,
    isScrolling = _ref.isScrolling,
    onMouseMove = _ref.onMouseMove;
  var childElementRef = useRef(null);
  useEffect(function () {
    // Do not measure if the row is not visible or is scrolling for performance reasons.
    if (!childElementRef.current || !isVisible || isScrolling) {
      return;
    }
    var observer = new ResizeObserver(function () {
      return measure();
    });
    observer.observe(childElementRef.current);
    return function () {
      return observer.disconnect();
    };
  }, [isScrolling, isVisible, measure]);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    React.createElement("div", {
      ref: ref,
      style: style,
      "data-index": index
    }, /*#__PURE__*/React.createElement("div", {
      ref: childElementRef,
      "data-testid": "list-item-height-observed-".concat(index),
      onMouseMove: onMouseMove
    }, children))
  );
});